import {
  FETCH_START,
  FETCH_END,
  EXTENSION_LIST_SUCCESS,
  EXTENSION_TABLE_DATA_SUCCESS,
} from './ActionTypes';
import axios from '../../../../axios.conf';
import secureLocalStorage from 'react-secure-storage';
import { handleExecutionLog } from '../../../../components/ExecutionLogHandler';

export const fetchStart = () => {
  return {
    type: FETCH_START,
  };
};

export const fetchEnd = () => {
  return {
    type: FETCH_END,
  };
};

export const getExtensionList = () => {
  return async (dispatch) => {
    dispatch(fetchStart());
    try {
      const response = await getExtensionListAPI();
      dispatch(fetchEnd());
      const logNumber = response?.data?.log_number;
      if (response?.data?.response) {
        dispatch(getExtensionListSuccess(response.data.response));
      } else if (logNumber) {
        await handleExecutionLog(dispatch, logNumber);
      }
      return response;
    } catch (error) {
      dispatch(fetchEnd());
      throw error;
    }
  };
};

const getExtensionListAPI = () => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  return axios.get('table/catalog', { headers });
};

export const getExtensionListSuccess = (data) => {
  return {
    type: EXTENSION_LIST_SUCCESS,
    data,
  };
};

export const getExtensionTableData = (tableName) => {
  return async (dispatch) => {
    dispatch(fetchStart());
    try {
      const response = await getExtensionTableDataAPI(tableName);
      dispatch(fetchEnd());
      const logNumber = response?.data?.log_number;
      if (response?.data?.response) {
        dispatch(getExtensionTableDataSuccess(response.data.response));
      } else if (logNumber) {
        await handleExecutionLog(dispatch, logNumber);
      }
      return response;
    } catch (error) {
      dispatch(fetchEnd());
      throw error;
    }
  };
};

const getExtensionTableDataAPI = (tableName) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  return axios.get(`table/metadata/${tableName}`, { headers });
};

export const getExtensionTableDataSuccess = (data) => {
  return {
    type: EXTENSION_TABLE_DATA_SUCCESS,
    data,
  };
};
